import { render } from "./pageTitle.vue?vue&type=template&id=1e9ebad3&scoped=true&ts=true"
import script from "./pageTitle.vue?vue&type=script&lang=ts"
export * from "./pageTitle.vue?vue&type=script&lang=ts"

import "./pageTitle.vue?vue&type=style&index=0&id=1e9ebad3&scoped=true&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e9ebad3"]])

export default __exports__